import { render, staticRenderFns } from "./ActivatedEmail.vue?vue&type=template&id=5c0b6528&"
import script from "./ActivatedEmail.vue?vue&type=script&lang=js&"
export * from "./ActivatedEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports